import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Hero from './components/Hero';
import Services from './Services';
import Contact from './Contact';
import BookingPage from './BookingPage';
import Faq from './Faq';

export default function App() {
  const theme = createTheme();
  
  return (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <Navbar />
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Home/>} />
            <Route path='/services' element={<Services/>} />
            <Route path='/book' element={<BookingPage/>} />
            <Route path='/contact' element={<Contact/>} />
            <Route path='/gallery' element={<Hero/>} />
            <Route path='/faq' element={<Faq/>} />
          </Routes>
        </BrowserRouter>
        <Footer />
    </ThemeProvider>
  );
}

